export default class CurrencyApi {
    currency;
    currentConversions;

    getCurrency() {
        return this.currency.toUpperCase();
    }

    setCurrency(currency) {
        let newCurrency = currency.toLowerCase();
        if (this.currency !== newCurrency) {
            this.currency = newCurrency;
            this.currentConversions = CurrencyApi.fetchCurrentConversions(this.currency);
        }
    }

    async convert(value, otherCurrency) {
        otherCurrency = otherCurrency.toLowerCase();
        if (otherCurrency === this.currency) {
            return value;
        }
        this.currentConversions = await this.currentConversions;
        let factor = parseFloat(this.currentConversions[this.currency][otherCurrency]);
        return (value / factor).toFixed(2);
    }

    static fetchCurrentConversions(currency) {
        // console.log(`fetching ${currency}...`);
        let url = `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/${currency}.json`;
        return fetch(url)
            .then((res) => res.json())
            .catch(e => {
                throw 'Currency Api Server error'
            });
    }

}